@if (!!item) {
<svg height="100%" width="100%" viewBox="-24.7 8 249.4 304"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="'pr-cap-' + item.id" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#b7bdc6"/>
      <stop offset="0.5" stop-color="#eef1f4"/>
      <stop offset="1" stop-color="#a7adb7"/>
    </linearGradient>
    <clipPath [attr.id]="'pr-clip-' + item.id">
      <path d="M100 60 C78 60 66 80 66 106 C66 128 68 140 72 152 L94 208 L106 208 L128 152 C132 140 134 128 134 106 C134 80 122 60 100 60 Z"/>
    </clipPath>
  </defs>

  <!-- Liquid fill (clipped to the egg body + cone) -->
  <rect [attr.clip-path]="'url(#pr-clip-' + item.id + ')'" x="64" [attr.y]="y" [attr.height]="height" width="72" [attr.fill]="item.color || item.beverage?.color || '#d99a2b'"/>

  <!-- Clear PET body: rounded shoulders into a steep cone (very translucent) -->
  <path d="M100 60 C78 60 66 80 66 106 C66 128 68 140 72 152 L94 208 L106 208 L128 152 C132 140 134 128 134 106 C134 80 122 60 100 60 Z" fill="#eef4f8" fill-opacity="0.22" stroke="#0f0f0f" stroke-width="1.5" stroke-linejoin="round"/>
  <!-- Gloss highlight -->
  <path d="M78 84 C74 104 76 140 86 176" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" opacity="0.55"/>

  <!-- Knurled screw lid + neck ring -->
  <rect x="84" y="56" width="32" height="5" fill="#c9ced6" stroke="#7f8790"/>
  <rect x="80" y="42" width="40" height="14" rx="3" [attr.fill]="'url(#pr-cap-' + item.id + ')'" stroke="#7f8790" stroke-width="1.5"/>
  <g stroke="#7f8790" stroke-width="1">
    <line x1="86" y1="43" x2="86" y2="55"/>
    <line x1="92" y1="43" x2="92" y2="55"/>
    <line x1="98" y1="43" x2="98" y2="55"/>
    <line x1="104" y1="43" x2="104" y2="55"/>
    <line x1="110" y1="43" x2="110" y2="55"/>
    <line x1="116" y1="43" x2="116" y2="55"/>
  </g>
  <!-- Lid handle -->
  <path d="M120 47 C132 43 136 50 127 55" fill="none" stroke="#7f8790" stroke-width="2.5" stroke-linecap="round"/>

  <!-- Centre spunding post + red PRV cap, side gas port -->
  <rect x="97" y="26" width="6" height="16" fill="#c9ced6" stroke="#7f8790"/>
  <rect x="94" y="20" width="12" height="7" rx="2" fill="#c9ced6" stroke="#7f8790"/>
  <rect x="95.5" y="14" width="9" height="5" rx="2" fill="#e23b3b"/>
  <rect x="108" y="33" width="10" height="8" rx="2" fill="#c9ced6" stroke="#7f8790"/>

  <!-- Collection assembly: flange, butterfly valve + handle, catch container -->
  <rect x="90" y="208" width="20" height="7" rx="2" fill="#c9ced6" stroke="#7f8790"/>
  <rect x="92" y="215" width="16" height="9" rx="2" fill="#9aa0a8" stroke="#6f767f"/>
  <line x1="108" y1="219" x2="128" y2="214" stroke="#6f767f" stroke-width="3" stroke-linecap="round"/>
  <rect x="88" y="224" width="24" height="34" rx="4" fill="#eef4f8" fill-opacity="0.4" stroke="#9fb4c2" stroke-width="1.5"/>
  <rect x="90" y="256" width="20" height="5" rx="2" fill="#9aa0a8" stroke="#6f767f"/>
</svg>
}
